import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'

const EditNameShop = (props) => {
  const { setmodalEditNameShopOpen, modalEditNameShopOpen, dataShop } = props

  const { t } = useLocalization()
  const history = useHistory()
  // const params = useParams()

  const handleSubmit = async (data) => {
    setmodalEditNameShopOpen(false)
    try {
      await client.patch(`/shop/${data.id}`, {
        name: data.name,
      })
      message.success('สำเร็จ')
      history.push('/shop')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <>
      <Modal
        centered={true}
        title={t('rewards.shop.edit.titleNameShop')}
        open={modalEditNameShopOpen}
        onCancel={() => setmodalEditNameShopOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          handleSubmit={handleSubmit}
          doStatus="editNameShop"
          defaultValues={dataShop}
        />
      </Modal>
    </>
  )
}

EditNameShop.propTypes = {
  dataShop: PropTypes.object,
  setmodalEditNameShopOpen: PropTypes.func,
  modalEditNameShopOpen: PropTypes.bool,
}

export default EditNameShop
